export default "__VITE_ASSET__C1iwQ5g3__"